import { render, staticRenderFns } from "./ReferenceItem.vue?vue&type=template&id=41a7ed59&"
import script from "./ReferenceItem.vue?vue&type=script&lang=js&"
export * from "./ReferenceItem.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports